export const ROUTES = {
  ROOT: "/:accountName?",
  LOGOUT: "/:accountName/logout",
  DEVELOP: "/:accountName/develop",
  CHOOSE_ACCOUNT: "/:accountName/choose-account",
  ACCOUNTS: "/:accountName/accounts",
  CONFIGURE: "/:accountName/configure",
  GOVERN: "/:accountName/govern",
  DEMO_TOOL: "/:accountName/internal-demo-tool",
};

export const USER_ROUTE_SEGMENTS = {
  DETAILS: "details",
  OWNERSHIP: "ownership",
};

export const ORG_ROLE_ROUTE_SEGMENTS = {
  DETAILS: "details",
  PRINCIPALS: "principals",
  PRIVILEGES: "privileges",
  GRANTED_TO_ROLES: "granted-to-roles",
  GRANTED_ROLES: "granted-roles",
};

export const GUEST_ROUTES = {
  LOGIN_HANDLE: "/login/handle",
  LOGIN_ERROR: "/login/error",
  LOGIN: "/login",
  CREATE_ACCOUNT: "/create-account",
  CREATE_ORGANIZATION: "/signup",
  REGISTER_CONTINUE: "/registerContinue/:requestId",
  FIND_ORGANIZATION: "/find-organization",
};

export const GENERAL_ROUTES = {
  NO_ACCESS: "/access-error/no-access",
  LOGOUT: "/logout",
};

export const RESERVED_URL_SEARCH_PARAMS = {
  REDIRECT: "redirect",
};

export const AWS_ROUTES = {
  GETTING_STARTED: "/getting-started",
  LINK_FAILURE: "/aws-marketplace-linking-failure",
  LINK_ALREADY_LINKED: "/aws-marketplace-linking-already-linked",
};

export const GCP_ROUTES = {
  LINK_FAILURE: "/gcp-marketplace-linking-failure",
  LINK_ALREADY_LINKED: "/gcp-marketplace-linking-already-linked",
};
